/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {
    paddingVertical: TwTheme.values.spaces.pageHorizontal,
    paddingHorizontal: theme.spaces[4]
  },
  cardContainer: {
    paddingHorizontal: theme.spaces[4],
    paddingTop: 10,
    paddingBottom: 6,
    borderWidth: 1,
    borderColor: theme.primaryColors.base,
    borderRadius: theme.radius.md,
    width: '100%'
  },
  image: {
    width: 71,
    height: 70
  },
  contentText: {
    ...theme.textSizes.md
  },
  contentDesc: {
    ...theme.textSizes.sm,
    color: theme.textColors.secondary
  },
  //卡片底部区域
  divider: {
    borderWidth: 1,
    borderColor: '#D4D4D4',
    width: '100%',
    marginTop: 8
  },
  footerDesc: {
    color: theme.textColors.third
  }
});
